import router from './router';
import './commons/language.js';
import authCommon from './commons/authCommon.js';
import './skin/skinTwo/css/skinTwo.css';
import './authModules/assets/css/iconfont.css';
import './skin/greenEasy7Skin/css/greenEasy7Skin.css';
import './skin/skinOne/css/skinOne.css';

window.authCommon = authCommon;
window.app.modRouter.push(router);
let menuData = sessionStorage.getItem('menuData');
if (menuData) {
    router.mergeRoutes(JSON.parse(menuData), window.vue.$router.options.routes[1].children);
    window.vue.$router.addRoutes(window.vue.$router.options.routes);
}

// 全局导入组件
const requireComponent = require.context(
    // 其组件目录的相对路径
    '@/authModules/user/components/',
    // 是否查询其子目录
    false,
    /.(vue)$/
);
requireComponent.keys().forEach(fileName => {
    // 获取组件配置
    const componentConfig = requireComponent(fileName);

    // 获取组件的 PascalCase 命名
    const componentName = window.vue.$upperFirst(
        window.vue.$camelCase(
            // 剥去文件名开头的 `'./` 和结尾的扩展名
            fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
        )
    );
    // 全局注册组件
    window.vue.$mainVue.component(
        componentName,
        // 如果这个组件选项是通过 `export default` 导出的，
        // 那么就会优先使用 `.default`，否则回退到使用模块的根。
        componentConfig.default || componentConfig
    );
});
